//Custom components

//Services
import { useDashboardData } from '@/hooks/ReactQueryHooks/useDashboardQuery';
//Assets and miscellaneous
import type { DashboardType } from '@/types/Analytics.ts';
import { accountingFormatNumber } from '@/utils';
import Card from '../../UI/Card/index.tsx';
import { Widget } from '../constants';
import WidgetLayout from '../WidgetLayout';

type ProgrammaticSummaryRow = {
  name: string;
  description: string;
  investment: number;
  pipeline: number;
  underConstruction: number;
  completed: number;
};

export default function ProgrammaticSummary({ dashboard }: { dashboard: DashboardType }) {
  const fetchProgrammaticSummaryWidget = useDashboardData({
    dashboard,
    widget: Widget.PROGRAMMATIC_SUMMARY,
  });
  const programmaticSummary = fetchProgrammaticSummaryWidget?.data?.data;

  return (
    <>
      {programmaticSummary && (
        <WidgetLayout dashboard={dashboard} widget={Widget.PROGRAMMATIC_SUMMARY}>
          <Card title='Programmatic Summary' error={fetchProgrammaticSummaryWidget.isError}>
            <div className='w-full h-full'>
              <table className='divide-y divide-gray-200 w-full'>
                <thead className='bg-gray-50 border-primaryColor-normal'>
                  <tr>
                    <th className='px-6 py-4 text-left text-xs font-bold text-neutralColor-normal capitalize tracking-wider'>
                      Program Name
                    </th>
                    <th className='px-6 py-4 text-left text-xs font-bold text-neutralColor-normal capitalize tracking-wider'>
                      Program Description
                    </th>
                    <th className='px-6 py-4 text-left text-xs font-bold text-neutralColor-normal capitalize tracking-wider'>
                      City Investment
                    </th>
                    <th className='px-6 py-4 text-left text-xs font-bold text-neutralColor-normal capitalize tracking-wider'>
                      Pipeline (Units)
                    </th>
                    <th className='px-6 py-4 text-left text-xs font-bold text-neutralColor-normal capitalize tracking-wider'>
                      Under Construction (Units)
                    </th>
                    <th className='px-6 py-4 text-left text-xs font-bold text-neutralColor-normal capitalize tracking-wider'>
                      Completed (Units)
                    </th>
                  </tr>
                </thead>
                <tbody className='bg-white divide-y divide-gray-200'>
                  {programmaticSummary.map((data: ProgrammaticSummaryRow) => {
                    return (
                      <tr key={data.name} className='hover:bg-green-50 cursor-pointer'>
                        <td className='px-6 py-4'>{data.name}</td>
                        <td className='px-6 py-4'>{data.description}</td>
                        <td className='px-6 py-4'>
                          {accountingFormatNumber({
                            num: data.investment ? data.investment : 0,
                            format: 'en-US',
                            currency: 'USD',
                          })}
                        </td>
                        <td className='px-6 py-4'>{data.pipeline}</td>
                        <td className='px-6 py-4'>{data.underConstruction}</td>
                        <td className='px-6 py-4'>{data.completed}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </Card>
        </WidgetLayout>
      )}
    </>
  );
}
